export class PasswordExpiredError extends Error {
  constructor() {
    super('Failed to login. Password expired')
    this.name = 'PasswordExpiredError'
  }
}
